<template>
    <va-edit-layout>
        <ServiceFeeEventFee-form
            :id="id"
            :title="title"
            :item="item"
        ></ServiceFeeEventFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
